module.exports = __webpack_public_path__ + "media/images/faces/male/19-f51f0579c9caac80b3de0e6b6718d0b9.jpg";